import "../../style.scss";

import React from "react";

const ContentContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className="content-container">{children}</div>;
};

export default ContentContainer;
